"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHomepartInProgress = void 0;
var React = __importStar(require("react"));
var IconHomepartInProgress = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#464650", d: "M12,2 C11.724,2 11.5,2.224 11.5,2.5 C11.5,2.776 11.724,3 12,3 C16.962,3 21,7.037 21,12 C21,16.963 16.962,21 12,21 L12,19 L8,21.5 L12,24 L12,22 C17.514,22 22,17.514 22,12 C22,6.486 17.514,2 12,2" }),
        React.createElement("path", { fill: "#464650", d: "M13.6758,8.0322 C13.4158,7.9302 13.1288,8.0652 13.0318,8.3242 L11.3928,12.6962 L16.2228,15.9162 C16.3078,15.9722 16.4048,16.0002 16.4998,16.0002 C16.6608,16.0002 16.8198,15.9222 16.9158,15.7772 C17.0698,15.5482 17.0078,15.2372 16.7778,15.0842 L12.6078,12.3032 L13.9678,8.6762 C14.0648,8.4172 13.9338,8.1292 13.6758,8.0322" })))); };
exports.IconHomepartInProgress = IconHomepartInProgress;
exports.IconHomepartInProgress.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHomepartInProgress;
